// extracted by mini-css-extract-plugin
export default {"layoutContainer":"styles_layoutContainer__kjvOp","layout":"styles_layout__O3pzB","logo":"styles_logo__XOWQL"};